export default __webpack_public_path__ + "static/media/support-allied-tute-moroni.977a44fe.png";